<template>
  <div>
    <el-drawer
      :model-value="visible"
      :before-close="handleCerrarDrawer"
      :with-header="true"
      :direction="direction"
      size="75%"
      title="Buscar suaje"
    >
      <div class="margin-container">
        <el-row :gutter="24">
          <custom-input
            v-if="esFiltroVisible('CodigoSuaje')"
            v-model="CodigoSuaje"
            :label="'Codigo suaje'"
            :spanColumn="3"
            :settings="{
              placeholder: 'Buscar por codigo',
              disabled: esFiltroDeshabilitado('CodigoSuaje'),
            }"
          />
          <custom-input
            v-if="esFiltroVisible('CodigoAdicional')"
            v-model="CodigoAdicional"
            :label="'Código adicional'"
            :spanColumn="3"
            :settings="{
              placeholder: 'Mínimo 3 caracteres',
              disabled: esFiltroDeshabilitado('CodigoAdicional'),
            }"
          />
          <custom-select
            v-if="esFiltroVisible('Material')"
            v-model="Material"
            :label="'Familia item'"
            :spanColumn="4"
            :settings="{
              placeholder: 'Seleccionar item',
              options: materiaPrimaFamilias,
              disabled: esFiltroDeshabilitado('Material'),
            }"
          />
          <custom-select
            v-if="esFiltroVisible('Forma')"
            v-model="Forma"
            :label="'Forma Suaje'"
            :spanColumn="4"
            :settings="{
              placeholder: 'Seleccionar forma',
              options: formaList,
              disabled: esFiltroDeshabilitado('Forma'),
            }"
          />
          <custom-select
            v-if="esFiltroVisible('CodigoSuajeTipo')"
            v-model="CodigoSuajeTipo"
            :label="'Tipo suaje'"
            :spanColumn="4"
            :settings="{
              placeholder: 'Seleccionar tipo de suaje',
              options: claseSuaje,
              disabled: esFiltroDeshabilitado('CodigoSuajeTipo'),
            }"
          />
          <custom-select
            v-if="esFiltroVisible('CodigoRecurso')"
            v-model="Recurso"
            :label="'Recurso'"
            :spanColumn="4"
            :settings="{
              placeholder: 'Seleccionar recurso',
              options: recursosList,
              filterable: true,
              clearable: true,
              disabled: esFiltroDeshabilitado('CodigoRecurso'),
            }"
            @click:clearable="Recurso = {}"
          />
        </el-row>
        <el-row :gutter="24">
          <el-col
            v-if="esFiltroVisible('Pleca')"
            :span="2"
          >
            <div class="custom-label">Pleca</div>
            <el-switch
              v-model="Pleca"
              class="mb-2"
              size="large"
            />
          </el-col>
          <custom-select
            v-model="EsAutomatica"
            :label="'Automática'"
            :spanColumn="3"
            :settings="{ options: opcionesAutomatica }"
          />
          <el-col :span="3">
            <div class="custom-label">Corte Completo</div>
            <el-switch
              v-model="EsCorteCompleto"
              class="mb-2"
              size="large"
            />
            <!-- <el-switch v-model="Pleca" class="mb-2" sieze="large" :disabled="esFiltroDeshabilitado('Pleca')" /> -->
          </el-col>
          <custom-input
            v-if="esFiltroVisible('Descripcion')"
            v-model="Descripcion"
            :label="'Descripción'"
            :spanColumn="5"
            :settings="{
              placeholder: 'Mínimo 3 caracteres',
              disabled: esFiltroDeshabilitado('Descripcion'),
            }"
          />
          <custom-input
            v-if="esFiltroVisible('Observaciones')"
            v-model="Observaciones"
            :label="'Observaciones'"
            :spanColumn="5"
            :settings="{
              placeholder: 'Mínimo 3 caracteres',
              disabled: esFiltroDeshabilitado('Observaciones'),
            }"
          />
        </el-row>
        <el-row :gutter="24">
          <custom-input-number
            v-if="esFiltroVisible('MedidaEje')"
            v-model="MedidaEje"
            :label="'Medida al eje'"
            :spanColumn="3"
            :settings="{
              inputClass: 'ancho_total',
              placeholder: 'Medida al eje',
              min: 0,
              precision: 4,
              step: 0.01,
              controls: false,
              disabled: esFiltroDeshabilitado('MedidaEje'),
            }"
          />
          <custom-input-number
            v-if="esFiltroVisible('MedidaDesarrollo')"
            v-model="MedidaDesarrollo"
            :label="'Medida al Desarrollo'"
            :spanColumn="3"
            :settings="{
              placeholder: 'Medida al Desarrollo',
              inputClass: 'ancho_total',
              min: 0,
              precision: 4,
              step: 0.01,
              controls: false,
              disabled: esFiltroDeshabilitado('MedidaDesarrollo'),
            }"
          />
          <custom-input-number
            v-if="esFiltroVisible('EtiquetasEje', false)"
            v-model="EtiquetasEje"
            :label="'Etiquetas al Eje'"
            :spanColumn="3"
            :settings="{
              inputClass: 'ancho_total',
              placeholder: 'Etiquetas al Eje',
              min: 0,
              precision: 0,
              step: 1,
              controls: false,
              disabled: esFiltroDeshabilitado('EtiquetasEje'),
            }"
          />
          <custom-input-number
            v-if="esFiltroVisible('EtiquetasDesarrollo', false)"
            v-model="EtiquetasDesarrollo"
            :label="'Etiquetas al Desarrollo'"
            :spanColumn="3"
            :settings="{
              inputClass: 'ancho_total',
              placeholder: 'Etiquetas al Desarrollo',
              min: 0,
              precision: 0,
              step: 1,
              controls: false,
              disabled: esFiltroDeshabilitado('EtiquetasDesarrollo'),
            }"
          />
          <el-col
            v-if="esFiltroVisible('Tolerancia')"
            :span="3"
            style="width: 100%"
          >
            <div class="custom-label">Tolerancia</div>
            <el-input-number
              ref="inputRef"
              v-model="Tolerancia"
              :precision="2"
              :step="0.1"
              :max="10"
              :formatter="formatter"
              :parser="parser"
              size="default"
              :disabled="esFiltroDeshabilitado('Tolerancia')"
              @focus="handleFocus"
              @blur="handleBlur(Tolerancia)"
            />
          </el-col>
          <el-col
            v-if="esFiltroVisible('UnidadMedida')"
            :span="3"
          >
            <div class="custom-label">Unidad medida</div>
            <el-radio-group
              v-model="UnidadMedida"
              size="default"
              :disabled="esFiltroDeshabilitado('UnidadMedida')"
            >
              <el-radio-button
                label="mm"
                value="mm"
              />
              <el-radio-button
                label="in"
                value="in"
              />
            </el-radio-group>
          </el-col>
          <el-col
            v-if="adaptadores"
            :span="3"
          >
            <div class="custom-label">Engrane Troquel en stock</div>
            <el-switch
              v-model="soloEnStock"
              class="mb-2"
              size="large"
            />
          </el-col>
          <el-col
            :span="5"
            class="button-container"
          >
            <el-button
              type="primary"
              size="default"
              @click="filtrar"
              >Buscar</el-button
            >
            <el-popover
              placement="right"
              :width="40"
              effect="dark"
              trigger="hover"
              content="Limpiar filtros"
            >
              <template #reference>
                <el-button
                  type="danger"
                  size="default"
                  :icon="IconDelete"
                  @click="limpiarFiltros"
                ></el-button>
              </template>
            </el-popover>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-table
          :data="swagesList"
          border
          stripe
          empty-text="No hay suajes compatibles"
          max-height="45vh"
        >
          <el-table-column label="Suaje">
            <el-table-column
              v-for="columna in columnasSuaje"
              :key="columna.prop"
              :prop="columna.prop"
              :label="columna.label"
              :width="columna.width"
              show-overflow-tooltip
            >
              <template #default="{ row }">
                <template v-if="columna.prop === 'SuajeTipo.Descripcion'">
                  <span v-if="row.SuajeTipo">{{ row.SuajeTipo.Descripcion }}</span>
                  <span
                    v-else
                    class="text-muted"
                    >-</span
                  >
                </template>
                <template v-else-if="columna.prop === 'Engranaje'">
                  {{ calcularEngranaje(row) }}
                </template>
                <template v-else>
                  {{ row[columna.prop] }}
                </template>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column v-if="adaptadores">
            <el-table-column
              v-for="columna in columnasAdaptador"
              :key="columna.prop"
              :prop="columna.prop"
              :label="columna.label"
              :width="columna.width"
            >
              <template #default="{ row }">
                <template v-if="row.Adaptador">
                  <el-tag
                    v-if="row.Adaptador.tipo === 'plano' && row.Adaptador.enStock"
                    type="success"
                    size="small"
                    >e={{ row.Adaptador.e }} r={{ row.Adaptador.r }}</el-tag
                  >
                  <el-tag
                    v-else-if="row.Adaptador.tipo === 'plano' && !row.Adaptador.enStock"
                    type="warning"
                    size="small"
                    >e={{ row.Adaptador.e }}* r={{ row.Adaptador.r }}</el-tag
                  >
                  <el-tag
                    v-else
                    type="danger"
                    size="small"
                    >ROT* r={{ row.Adaptador.r }}</el-tag
                  >
                </template>
                <span
                  v-else
                  class="text-muted"
                  >No aplica</span
                >
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="Impresion">
            <el-table-column
              v-for="columna in columnasImpresion"
              :key="columna.prop"
              :prop="columna.prop"
              :label="columna.label"
              :width="columna.width"
            >
              <template #default="{ row }">
                <template v-if="columna.prop === 'EtiquetasDesarrolloImpresion'">
                  {{ calcularEtiquetasDesarrolloImpresion(row) }}
                </template>
                <template v-else-if="columna.prop === 'EngranajeImpresion'">
                  {{ row.Adaptador?.Desarrollo?.Engranaje }}
                </template>
                <template v-else-if="columna.prop === 'DesarrolloImpresion'">
                  {{ calcularDesarrolloImpresion(row) }}
                </template>
                <template v-else>
                  {{ row[columna.prop] }}
                </template>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column fixed="right">
            <el-table-column
              v-for="columna in columnasAcciones"
              :key="columna.prop"
              :prop="columna.prop"
              :label="columna.label"
              :width="columna.width"
              fixed="right"
            >
              <template #default="{ row }">
                <el-button
                  type="primary"
                  @click="seleccionerSuaje(row)"
                  >Usar</el-button
                >
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
      <div class="exit-button-container">
        <el-button
          type="danger"
          @click="handleCerrarDrawer"
          >Salir</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>

<script setup>
import {
  ref,
  computed,
  onBeforeMount,
  watch,
  toRef,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useFormaStore } from '@/stores/forma/forma_store';
import { useSwageStore } from '@/stores/swage_store.js';
import { useMateriaPrimaFamiliaStore } from '@/stores/materia_prima_familia/materia_prima_familia_store.js';
import CustomSelect from '@/shared/components/custom_select.vue';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import IconDelete from '~icons/mdi/delete';
import SuajeService from '@/services/suaje_service';
import FormaService from '@/services/forma_service';
import SuajeTipoService from '@/services/suaje_tipo_service';
import MateriaPrimaFamiliaService from '@/services/materia_prima_familia_service';
import RecursoService from '@/services/recurso_service';
import { getParamsUrl } from '@/views/swage/swage_utils.js';
import { calcularEtiquetasDesarrolloImpresion } from '@/shared/composables/useSuajeAdaptador.js';
import { useLocaleNumberInput } from '@/shared/composables/useLocaleNumberInput.js';

const { inputRef, formatter, parser, handleFocus, handleBlur } = useLocaleNumberInput(2);

const props = defineProps({
  visible: { type: Boolean, default: false },
  /**
   * Configuración de filtros predefinidos.
   * Cada clave es el nombre del filtro (CodigoSuaje, CodigoAdicional, Descripcion,
   * Observaciones, Material, Forma, CodigoSuajeTipo, Pleca, MedidaEje, MedidaDesarrollo,
   * Tolerancia, UnidadMedida).
   * Cada valor es un objeto con:
   *   - valor: valor inicial del filtro
   *   - visible: si el filtro se muestra (default: true)
   *   - deshabilitado: si el filtro es visible pero no editable (default: false)
   *
   * Ejemplo:
   * {
   *   CodigoSuajeTipo: { valor: { Codigo: 1 }, visible: true, deshabilitado: true },
   *   Pleca: { visible: false }
   * }
   */
  medidaEjeMm: { type: Number, default: 0 },
  medidaDesarrolloMm: { type: Number, default: 0 },
  medidaEjeIn: { type: Number, default: 0 },
  medidaDesarrolloIn: { type: Number, default: 0 },
  unidadMedida: { type: String, default: 'mm' },
  filtros: { type: Object, default: () => ({}) },
  /**
   * Determina cómo se obtienen los suajes:
   *   - true: usa SuajeService.findAllWithAdaptadoresQuery (incluye cálculo de adaptadores).
   *   - false (default): usa firstSwage() del swageStore (listado simple de suajes).
   */
  adaptadores: { type: Boolean, default: false },
});

const visibleRef = toRef(props, 'visible');

const emits = defineEmits(['cerrarBuscarSuaje', 'seleccionarSuaje']);

const swageStore = useSwageStore();

const direction = ref('btt');
const CodigoSuaje = ref('');
const CodigoAdicional = ref('');
const Descripcion = ref('');
const Observaciones = ref('');
const Material = ref({});
const Forma = ref({});
const CodigoSuajeTipo = ref({});
const Recurso = ref({});
const Pleca = ref(false);
// "Todos" no envía el parámetro EsAutomatica (getParamsUrl lo omite si es undefined)
const opcionesAutomatica = [
  { Codigo: 'todos', Descripcion: 'Todos' },
  { Codigo: 'si', Descripcion: 'Sí' },
  { Codigo: 'no', Descripcion: 'No' },
];
const valorEsAutomatica = { todos: undefined, si: true, no: false };
const EsAutomatica = ref(opcionesAutomatica[1]);
const EsCorteCompleto = ref(false);
const MedidaEje = ref(0);
const MedidaDesarrollo = ref(0);
const EtiquetasEje = ref(0);
const EtiquetasDesarrollo = ref(0);
const Tolerancia = ref(0);
const UnidadMedida = ref(props.unidadMedida || 'mm');

// Inicializar valores según la unidad de medida de las props
MedidaEje.value = props.unidadMedida === 'in' ? props.medidaEjeIn : props.medidaEjeMm;
MedidaDesarrollo.value =
  props.unidadMedida === 'in' ? props.medidaDesarrolloIn : props.medidaDesarrolloMm;
const page = ref(1);
const swagesListLocal = ref([]);
const claseSuaje = ref([]);
const formaList = ref([]);
const recursosList = ref([]);
const materiaPrimaFamilias = ref([]);
const soloEnStock = ref(false);

// Filtro "Solo en stock" (sólo aplica con adaptadores=true): deja pasar los suajes que no
// son planos y, de los planos, sólo los que tengan el adaptador en stock.
const swagesList = computed(() => {
  if (!props.adaptadores || !soloEnStock.value) return swagesListLocal.value;

  return swagesListLocal.value.filter((row) => {
    const esPlano = row?.SuajeTipo?.ClaveInterna === 'plano';
    return !esPlano || row?.Adaptador?.enStock === true;
  });
});

const getFiltroCfg = (nombre) => props.filtros?.[nombre] || {};

const esFiltroVisible = (nombre, defaultVisible = true) => {
  const visible = getFiltroCfg(nombre).visible;
  return visible !== undefined ? visible : defaultVisible;
};

const esFiltroDeshabilitado = (nombre) => getFiltroCfg(nombre).deshabilitado === true;

const inicializarFiltros = () => {
  CodigoSuaje.value = getFiltroCfg('CodigoSuaje').valor ?? '';
  CodigoAdicional.value = getFiltroCfg('CodigoAdicional').valor ?? '';
  Descripcion.value = getFiltroCfg('Descripcion').valor ?? '';
  Observaciones.value = getFiltroCfg('Observaciones').valor ?? '';
  Material.value = getFiltroCfg('Material').valor ?? {};
  Forma.value = getFiltroCfg('Forma').valor ?? {};

  // Si el valor es un string se asume que es ClaveInterna; buscar en la lista cargada
  const valorTipo = getFiltroCfg('CodigoSuajeTipo').valor;
  if (typeof valorTipo === 'string') {
    CodigoSuajeTipo.value = claseSuaje.value.find((t) => t.ClaveInterna === valorTipo) ?? {};
  } else {
    CodigoSuajeTipo.value = valorTipo ?? {};
  }

  Recurso.value = getFiltroCfg('CodigoRecurso').valor ?? {};
  Pleca.value = getFiltroCfg('Pleca').valor ?? false;
  // Medidas y unidad ya se inicializan desde las props al abrir el drawer;
  // sólo se pisan acá si el filtro las define explícitamente.
  MedidaEje.value = getFiltroCfg('MedidaEje').valor ?? MedidaEje.value;
  MedidaDesarrollo.value = getFiltroCfg('MedidaDesarrollo').valor ?? MedidaDesarrollo.value;
  EtiquetasEje.value = getFiltroCfg('EtiquetasEje').valor ?? 0;
  EtiquetasDesarrollo.value = getFiltroCfg('EtiquetasDesarrollo').valor ?? 0;
  Tolerancia.value = getFiltroCfg('Tolerancia').valor ?? 0;
  UnidadMedida.value = getFiltroCfg('UnidadMedida').valor ?? UnidadMedida.value;
};

const handleCerrarDrawer = () => {
  emits('cerrarBuscarSuaje');
};

// Agrupación de columnas
const columnasSuaje = [
  {
    prop: 'CodigoSuaje',
    label: 'Clave',
    width: '120px',
  },
  {
    prop: 'CodigoAdicional',
    label: 'Código adicional',
    width: '150px',
  },
  {
    prop: 'SuajeTipo.Descripcion',
    label: 'Tipo',
    width: '100px',
  },
  {
    prop: 'MedidaEjeMm',
    label: 'Medida al Eje',
    width: '100px',
  },
  {
    prop: 'MedidaDesarrolloMm',
    label: 'Medida Desarrollo',
    width: '80px',
  },
  {
    prop: 'EtiquetasEje',
    label: 'Bocas Eje',
    width: '100px',
  },
  {
    prop: 'EtiquetasDesarrollo',
    label: 'Bocas Desarrollo',
    width: '100px',
  },
  {
    prop: 'GapEjeMm',
    label: 'Gap al Eje',
    width: '80px',
  },
  {
    prop: 'GapDesarrolloMm',
    label: 'Gap Des.',
    width: '80px',
  },
  {
    prop: 'AnchoOptimoMaterial',
    label: 'Ancho',
    width: '80px',
  },
  {
    prop: 'Desarrollo',
    label: 'Desarrollo',
    width: '80px',
  },
  {
    prop: 'Engranaje',
    label: 'Engranaje',
    width: '80px',
  },
  {
    prop: 'Descripcion',
    label: 'Descripción',
    width: '200px',
  },
  {
    prop: 'Observaciones',
    label: 'Observaciones',
    width: '200px',
  },
];
const columnasAdaptador = [
  {
    prop: 'Adaptador',
    label: 'Relacion',
    width: '120px',
  },
];
const columnasImpresion = [
  {
    prop: 'EtiquetasEje',
    label: 'Bocas Eje',
    width: '80px',
  },
  {
    prop: 'EtiquetasDesarrolloImpresion',
    label: 'Bocas Desarrollo',
    width: '80px',
  },
  {
    prop: 'EngranajeImpresion',
    label: 'Z',
    width: '80px',
  },
  {
    prop: 'DesarrolloImpresion',
    label: 'Desarrollo',
    width: '180px',
  },
];
const columnasAcciones = [
  {
    prop: 'acciones',
    label: 'Acciones',
    template: 'accionesTemplate',
    width: '120px',
  },
];

// Desarrollo de impresión: si el suaje es plano se usa el desarrollo del cilindro del
// adaptador (Adaptador.Desarrollo.Desarrollo); si no es plano, se usa el Desarrollo del suaje.
const calcularDesarrolloImpresion = (row) => {
  const esPlano = row?.SuajeTipo?.ClaveInterna === 'plano';
  return esPlano ? row?.Adaptador?.Desarrollo?.Desarrollo : row?.Desarrollo;
};

// Engranaje: si el suaje es plano se usa la cantidad de dientes del adaptador (Adaptador.e);
// si no es plano, se usa el Engranaje del suaje.
const calcularEngranaje = (row) => {
  const esPlano = row?.SuajeTipo?.ClaveInterna === 'plano';
  return esPlano ? row?.Adaptador?.e : row?.Engranaje;
};

const seleccionerSuaje = (suaje) => {
  if (suaje) {
    emits('seleccionarSuaje', suaje);
    handleCerrarDrawer();
  }
};

const filtrar = async () => {
  if (!props.adaptadores) {
    await filtrarConSwageStore();
    return;
  }

  const filters = {};
  if (CodigoSuaje.value) {
    filters['CodigoSuaje'] = CodigoSuaje.value;
  }
  if (CodigoAdicional.value) {
    filters['CodigoAdicional'] = CodigoAdicional.value;
  }
  if (Descripcion.value) {
    filters['Descripcion'] = Descripcion.value;
  }
  if (Observaciones.value) {
    filters['Observaciones'] = Observaciones.value;
  }
  if (Material.value?.Codigo) {
    filters['CodigoMateriaPrimaFamilia'] = Material.value.Codigo;
  }
  if (Forma.value?.Codigo) {
    filters['Forma'] = Forma.value;
  }
  // Usar ClaveInterna del objeto seleccionado, o directamente del valor prop si es string
  const claveInterna =
    CodigoSuajeTipo.value?.ClaveInterna ??
    (typeof getFiltroCfg('CodigoSuajeTipo').valor === 'string'
      ? getFiltroCfg('CodigoSuajeTipo').valor
      : null);
  if (claveInterna) {
    filters['ClaveInternaSuajeTipo'] = claveInterna;
  }
  if (Recurso.value?.Codigo) {
    filters['CodigoRecurso'] = Recurso.value.Codigo;
  }
  if (Pleca.value) {
    filters['Pleca'] = Pleca.value;
  }
  if (MedidaEje.value) {
    filters['MedidaEjeMm'] = MedidaEje.value;
  }
  if (MedidaDesarrollo.value) {
    filters['MedidaDesarrolloMm'] = MedidaDesarrollo.value;
  }
  if (EtiquetasEje.value) {
    filters['EtiquetasEje'] = EtiquetasEje.value;
  }
  if (EtiquetasDesarrollo.value) {
    filters['EtiquetasDesarrollo'] = EtiquetasDesarrollo.value;
  }
  if (Tolerancia.value) {
    filters['Tolerancia'] = Tolerancia.value;
  }
  if (UnidadMedida.value === 'in') {
    filters['MedidaEjeIn'] = MedidaEje.value;
    filters['MedidaDesarrolloIn'] = MedidaDesarrollo.value;
    delete filters['MedidaEjeMm'];
    delete filters['MedidaDesarrolloMm'];
  }

  page.value = 1;
  await cargarSuajesConAdaptadores(filters);
};

// adaptadores=false: listado simple de suajes (sin cálculo de adaptadores) vía swageStore.firstSwage()
const filtrarConSwageStore = async () => {
  try {
    swageStore.setFilters({
      ...swageStore.swageFilters,
      CodigoSuaje: CodigoSuaje.value || null,
      CodigoAdicional: CodigoAdicional.value || null,
      Descripcion: Descripcion.value || null,
      Observaciones: Observaciones.value || null,
      Material: Material.value,
      CodigoMateriaPrimaFamilia: Material.value?.Codigo ?? null,
      Forma: Forma.value,
      CodigoSuajeTipo: CodigoSuajeTipo.value,
      Pleca: Pleca.value,
      TienePleca: Pleca.value,
      EsAutomatica: valorEsAutomatica[EsAutomatica.value?.Codigo],
      EsCorteCompleto: EsCorteCompleto.value,
      MedidaEje: MedidaEje.value,
      MedidaDesarrollo: MedidaDesarrollo.value,
      Tolerancia: Tolerancia.value,
      UnidadMedida: UnidadMedida.value,
    });

    page.value = 1;
    await swageStore.firstSwage();
    swagesListLocal.value = swageStore.swagesList;
  } catch (error) {
    console.error('[filtrarConSwageStore] Error al cargar suajes desde el store:', error);
  }
};

const cargarSuajesConAdaptadores = async (filters = {}) => {
  try {
    console.log('[cargarSuajesConAdaptadores] Inicio - filters recibidos:', filters);

    // Asegurar que los filtros booleanos siempre se envíen
    const queryParams = {
      page: 0,
      TienePleca: Pleca.value,
      EsAutomatica: valorEsAutomatica[EsAutomatica.value?.Codigo],
      EsCorteCompleto: EsCorteCompleto.value,
      UnidadMedida: UnidadMedida.value,
      ...filters,
    };

    // Agregar medidas si tienen valores (usar nombres sin unidad para que getParamsUrl los procese)
    if (MedidaEje.value) {
      queryParams.MedidaEje = MedidaEje.value;
    }
    if (MedidaDesarrollo.value) {
      queryParams.MedidaDesarrollo = MedidaDesarrollo.value;
    }

    console.log('[cargarSuajesConAdaptadores] queryParams construidos:', queryParams);

    const queryString = getParamsUrl(queryParams);
    console.log('[cargarSuajesConAdaptadores] queryString:', queryString);

    const result = await SuajeService.findAllWithAdaptadoresQuery(queryString);
    console.log('[cargarSuajesConAdaptadores] resultado recibido:', result?.data);

    if (result && result.data) {
      swagesListLocal.value = result.data;
      console.log(
        '[cargarSuajesConAdaptadores] swagesListLocal actualizado con',
        result.data.length,
        'registros',
      );
    } else {
      console.warn('[cargarSuajesConAdaptadores] No se recibieron datos del backend');
    }
  } catch (error) {
    console.error('[cargarSuajesConAdaptadores] Error al cargar suajes con adaptadores:', error);
  }
};

const cargarMateriaPrimaFamilias = async () => {
  try {
    const result = await MateriaPrimaFamiliaService.findAll();
    if (result && result.data) {
      materiaPrimaFamilias.value = result.data;
    }
  } catch (error) {
    console.error('Error al cargar familias de materia prima:', error);
  }
};

const cargarFormas = async () => {
  try {
    const result = await FormaService.findAll();
    if (result && result.data) {
      formaList.value = result.data;
    }
  } catch (error) {
    console.error('Error al cargar formas de suaje:', error);
  }
};

const cargarRecursos = async () => {
  try {
    const result = await RecursoService.findAll('page=0');
    if (result && result.data) {
      // Sólo se ofrecen como opción los recursos con tipo de cilindro asignado
      recursosList.value = result.data.filter((recurso) =>
        Number.isFinite(Number.parseFloat(recurso.CodigoTipoCilindro)),
      );
    }
  } catch (error) {
    console.error('Error al cargar recursos:', error);
  }
};

const cargarSuajeTipos = async () => {
  try {
    const result = await SuajeTipoService.findAll();
    if (result && result.data) {
      claseSuaje.value = result.data;
    }
  } catch (error) {
    console.error('Error al cargar tipos de suaje:', error);
  }
};

const limpiarFiltros = async () => {
  CodigoSuaje.value = '';
  CodigoAdicional.value = '';
  Descripcion.value = '';
  Observaciones.value = '';
  Material.value = {};
  Forma.value = {};
  CodigoSuajeTipo.value = {};
  Recurso.value = {};
  Pleca.value = false;
  EsAutomatica.value = opcionesAutomatica[1];
  EsCorteCompleto.value = false;
  MedidaEje.value = props.medidaEje || 0;
  MedidaDesarrollo.value = props.medidaDesarrollo || 0;
  EtiquetasEje.value = getFiltroCfg('EtiquetasEje').valor ?? 0;
  EtiquetasDesarrollo.value = getFiltroCfg('EtiquetasDesarrollo').valor ?? 0;
  Tolerancia.value = 0;
  UnidadMedida.value = 'mm';
  soloEnStock.value = false;
  page.value = 1;
  if (!props.adaptadores) {
    await filtrarConSwageStore();
  } else {
    await cargarSuajesConAdaptadores();
  }
};

watch(visibleRef, async (newVal, oldVal) => {
  if (newVal) {
    // Actualizar valores iniciales con las props según la unidad de medida
    UnidadMedida.value = props.unidadMedida || 'mm';
    MedidaEje.value = props.unidadMedida === 'in' ? props.medidaEjeIn : props.medidaEjeMm;
    MedidaDesarrollo.value =
      props.unidadMedida === 'in' ? props.medidaDesarrolloIn : props.medidaDesarrolloMm;

    await Promise.all([
      cargarMateriaPrimaFamilias(),
      cargarFormas(),
      cargarSuajeTipos(),
      cargarRecursos(),
    ]);

    inicializarFiltros();
    await filtrar();
  }
});

// Watch para actualizar valores cuando cambia la unidad de medida
watch(UnidadMedida, (newUnit) => {
  // Actualizar los valores según la nueva unidad
  MedidaEje.value = newUnit === 'in' ? props.medidaEjeIn : props.medidaEjeMm;
  MedidaDesarrollo.value = newUnit === 'in' ? props.medidaDesarrolloIn : props.medidaDesarrolloMm;
});
</script>

<style scoped>
/* Reduce el espacio entre el título del drawer y el contenido
   (Element Plus pone margin-bottom: 32px en el header y padding-top: 20px en el body) */
:deep(.el-drawer__header) {
  margin-bottom: 0;
}

:deep(.el-drawer__body) {
  padding-top: 8px;
}

.custom-label {
  font-weight: 700;
  color: #111;
}

.margin-container {
  padding: 1%;
}

.exit-button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.button-container {
  margin-top: auto;
}

.text-muted {
  color: #909399;
}
</style>
